<template>
  <import-clients-modal
    ref="modal"
    :can-upload="canImport"
  />
</template>

<script>

import utilsMixin from '@/_utilities/utilsMixin';
import { EventBus } from '@/event-bus';
import integrable from '@/components/mixins/integrable';
import ImportClientsModal from './ImportClientsModal';

export default {
  components: {
    ImportClientsModal,
  },
  mixins: [utilsMixin, integrable],
  computed: {
    canImport() {
      return this.useFeature('import_clients') && this.isIntegrated;
    },
  },
  mounted() {
    EventBus.$on('open-add-client-modal', this.open);
  },
  methods: {
    open() {
      this.$nextTick().then(() => {
        if (this.$refs.modal) {
          this.$refs.modal.open();
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
